/**
 * Single source for Meta/Facebook OAuth config. All values come from env vars:
 * - Local: use .env.local (REACT_APP_META_CLIENT_ID, REACT_APP_META_REDIRECT_URI). No secret: see oauthTokenExchange.
 * - Production: set same vars in Amplify (or your host) environment
 */
const getEnv = (key: string): string => {
  const value = process.env[key];
  return typeof value === "string" ? value : "";
};

export const getMetaClientId = (): string =>
  getEnv("REACT_APP_META_CLIENT_ID");

export const getMetaRedirectUri = (): string =>
  getEnv("REACT_APP_META_REDIRECT_URI");

/** Redirect URI for Facebook OAuth; falls back to origin + path when env is unset (e.g. local). */
export const getFacebookRedirectUri = (): string => {
  const fromEnv = getMetaRedirectUri();
  if (fromEnv) return fromEnv;
  return `${window.location.origin}/connect/facebook/callback`;
};

/** Throws if the app id is missing. The app SECRET is never in the browser: codes
 *  are exchanged on the server (services/oauthTokenExchange). */
export const requireMetaAppCredentials = (): { clientId: string } => {
  const clientId = getMetaClientId();
  if (!clientId?.trim()) {
    throw new Error(
      "REACT_APP_META_CLIENT_ID is not set. For local development, add it to .env.local and restart the dev server."
    );
  }
  return { clientId };
};
